var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.538,
    height: 21.538,
    viewBox: "0 0 21.538 21.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.154 -2.154)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.385,
    cy: 5.385,
    r: 5.385,
    transform: "translate(7.538 7.538)",
    fill: "#efd94c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.615,14H21.538a1.077,1.077,0,1,1,0-2.154h1.077a1.077,1.077,0,0,1,0,2.154Z",
    fill: "#efd94c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.308,14H3.231a1.077,1.077,0,0,1,0-2.154H4.308a1.077,1.077,0,1,1,0,2.154Z",
    fill: "#efd94c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.018,7.9a1.073,1.073,0,0,1-.711-1.831l.765-.765a1.077,1.077,0,1,1,1.518,1.518l-.765.765A1.077,1.077,0,0,1,19.018,7.9Z",
    fill: "#efd94c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.074,20.849a1.072,1.072,0,0,1-.765-1.831l.765-.711a1.077,1.077,0,0,1,1.518,1.518l-.765.765A1.077,1.077,0,0,1,6.074,20.849Z",
    fill: "#efd94c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.923,5.385a1.077,1.077,0,0,1-1.077-1.077V3.231a1.077,1.077,0,1,1,2.154,0V4.308A1.077,1.077,0,0,1,12.923,5.385Z",
    fill: "#efd94c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.923,23.692a1.077,1.077,0,0,1-1.077-1.077V21.538a1.077,1.077,0,1,1,2.154,0v1.077A1.077,1.077,0,0,1,12.923,23.692Z",
    fill: "#efd94c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.828,7.9a1.077,1.077,0,0,1-.754-.312l-.765-.765A1.077,1.077,0,0,1,6.828,5.309l.765.765A1.072,1.072,0,0,1,6.828,7.9Z",
    fill: "#efd94c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.772,20.849a1.077,1.077,0,0,1-.754-.312l-.711-.765a1.077,1.077,0,0,1,1.465-1.465l.765.765a1.021,1.021,0,0,1-.765,1.777Z",
    fill: "#efd94c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/Sun.92800749912ac79b2fb24f5fe1981b26.svg";
export { ForwardRef as ReactComponent };